import React, { useState } from "react";
import { Box, IconButton, MenuItem, Select, Typography, Button, Grid, useMediaQuery } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

// const RoomBookingTable = () => {
//   const [rooms, setRooms] = useState([
//     { adult: 2, child: 2, baby: 2 },
//   ]);

//   const handleAddRoom = () => {
//     setRooms([...rooms, { adult: 2, child: 2, baby: 2 }]);
//   };

//   const handleRemoveRoom = (index) => {
//     const newRooms = rooms.filter((_, i) => i !== index);
//     setRooms(newRooms);
//   };

//   const handleChange = (index, field, value) => {
//     const newRooms = [...rooms];
//     newRooms[index][field] = value;
//     setRooms(newRooms);
//   };

//   const options = [1, 2, 3, 4, 5];

//   return (
//     <Box sx={{ width: "500px", margin: "auto", mt: 4,p:2 }}>
//       <Box sx={{ display: "flex", fontWeight: "bold", mb: 2 }}>
//         <Box sx={{ flex: 1 }}>Room</Box>
//         <Box sx={{ flex: 1,ml:2}}>Adult</Box>
//         <Box sx={{ flex: 1,ml:2 }}>Child</Box>
//         <Box sx={{ flex: 1,ml:2}}>Baby</Box>
//         <Box sx={{ width: 50 }}></Box>
//       </Box>

//       {rooms.map((room, index) => (
//         <Box
//           key={index}
//           sx={{ display: "flex", alignItems: "center", mb: 1 }}
//         >
//           <Typography sx={{ flex: 1 }}>{String(index + 1).padStart(2, "0")}</Typography>

//           <Select
//             value={room.adult}
//             onChange={(e) => handleChange(index, "adult", e.target.value)}
//             sx={{ flex: 1, mr: 1 }}
//           >
//             {options.map((opt) => (
//               <MenuItem key={opt} value={opt}>{String(opt).padStart(2, "0")}</MenuItem>
//             ))}
//           </Select>

//           <Select
//             value={room.child}
//             onChange={(e) => handleChange(index, "child", e.target.value)}
//             sx={{ flex: 1, mr: 1 }}
//           >
//             {options.map((opt) => (
//               <MenuItem key={opt} value={opt}>{String(opt).padStart(2, "0")}</MenuItem>
//             ))}
//           </Select>

//           <Select
//             value={room.baby}
//             onChange={(e) => handleChange(index, "baby", e.target.value)}
//             sx={{ flex: 1, mr: 1 }}
//           >
//             {options.map((opt) => (
//               <MenuItem key={opt} value={opt}>{String(opt).padStart(2, "0")}</MenuItem>
//             ))}
//           </Select>

//           <IconButton color="error" onClick={() => handleRemoveRoom(index)}>
//             <DeleteIcon />
//           </IconButton>
//         </Box>
//       ))}

//       <IconButton
//         variant="contained"
//         size="small"
//         onClick={handleAddRoom}
//         sx={{ mt: 2,float:"right",borderRadius:"5px",backgroundColor:"green",color:"#fff",m:1 }}
//       >
//         <AddIcon fontSize="small" />
//       </IconButton>
//     </Box>
//   );
// };


const RoomBookingTable = () => {
  const isSmallScreen=useMediaQuery('sm')
  const [rooms, setRooms] = useState([{ adult: 2, child: 2, baby: 2 }]);

  const handleAddRoom = () => {
    setRooms([...rooms, { adult: 2, child: 2, baby: 2 }]);
  };

  const handleRemoveRoom = (index) => {
    setRooms(rooms.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    const newRooms = [...rooms];
    newRooms[index][field] = value;
    setRooms(newRooms);
  };

  const options = [0, 1, 2, 3, 4, 5];

  return (
    <Box sx={{ width:isSmallScreen ? "100%" : 400, maxWidth: 700, p: 2 }}>
      
      {/* Header */}
      <Typography sx={{ fontWeight: 600, fontSize: "1.1rem", mb: 2 }}>
        Room Selection
      </Typography>

      {rooms.map((room, index) => (
        <Box
          key={index}
          sx={{
            p: 2,
            mb: 2,
            borderRadius: "12px",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
            background: "#fff",
          }}
        >
          {/* Room Label + Delete */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography sx={{ fontSize: "1rem", fontWeight: 600 }}>
              Room {String(index + 1).padStart(2, "0")}
            </Typography>

            {rooms.length > 1 && (
              <IconButton
                size="small"
                color="error"
                onClick={() => handleRemoveRoom(index)}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </Box>

          {/* Responsive Inputs */}
          <Grid container spacing={2}>
            {/* Adult */}
            <Grid item xs={4}>
              <Typography sx={{ fontSize: "0.8rem", mb: 0.5 }}>
                Adults
              </Typography>
              <Select
                value={room.adult}
                onChange={(e) => handleChange(index, "adult", e.target.value)}
                fullWidth
                size="small"
                sx={{ borderRadius: "8px" }}
              >
                {options.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {/* Child */}
            <Grid item xs={4}>
              <Typography sx={{ fontSize: "0.8rem", mb: 0.5 }}>
                Children
              </Typography>
              <Select
                value={room.child}
                onChange={(e) => handleChange(index, "child", e.target.value)}
                fullWidth
                size="small"
                sx={{ borderRadius: "8px" }}
              >
                {options.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {/* Baby */}
            <Grid item xs={4}>
              <Typography sx={{ fontSize: "0.8rem", mb: 0.5 }}>
                Baby
              </Typography>
              <Select
                value={room.baby}
                onChange={(e) => handleChange(index, "baby", e.target.value)}
                fullWidth
                size="small"
                sx={{ borderRadius: "8px" }}
              >
                {options.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        </Box>
      ))}

      {/* Add Room Button */}
      <Button
        variant="contained"
        onClick={handleAddRoom}
        sx={{
          backgroundColor: "#1E88E5",
          ":hover": { backgroundColor: "#1565C0" },
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 600,
          width: "100%",
          py: 1.2,
        }}
        startIcon={<AddIcon />}
      >
        Add Another Room
      </Button>
    </Box>
  );
};


export default RoomBookingTable;
